import React from "react";
import classNames from "classnames";
import { ErrorMessage, Field } from "formik";

const InputField = ({
  name,
  type,
  placeholder,
  form: { errors, touched },
  extraClass = "",
  ...props
}) => {
  return (
    <div className={`form_field ${extraClass}`}>
      <Field
        {...props}
        type={type || "text"}
        name={name}
        placeholder={placeholder}
        className={classNames(
          "input_field",
          errors[name] && touched[name] ? "input_error" : null
        )}
      />
      <ErrorMessage component="span" name={name} className="error" />
    </div>
  );
};

export default InputField;
